<template>
    <div class="flex flex-wrap gap-2">
        <Chip v-for="user in props.users" :key="user.id" :label="user.fullname" removable @remove="emit('remove-user', user.id)" />
        <!-- Show remove all button once there are more than 1 user selected -->
        <Button v-if="usersCount > 1" label="Remove all selected" severity="danger" @click="removeAll" />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useConfirmRemove } from '@/composables/ConfirmComposable';

const emit = defineEmits(['remove-user', 'remove-all-selected']);

const props = defineProps({
    users: Array,
});

const { confirmContinue } = useConfirmRemove();

const usersCount = computed(() => {
    return props.users?.length;
});

const removeAll = async () => {
    const message = 'Remove all selected users.';
    const confirm = await confirmContinue(message);
    if (confirm) {
        emit('remove-all-selected');
    }
};
</script>
